import type { PriceOrigin } from "./priceOrigin.ts";
import type { DerivedQuantity } from "./reinforcedConcreteEngine";

export type ResourcePrice = {
  code: string;
  name: string;
  unit: string;
  unit_price: number | null;
  effective_date: string | null;
  counterparty: string | null;
};

function unitKey(unit: string) {
  return unit.trim().replaceAll("²", "2").replaceAll("³", "3");
}

export function costResourceQuantities(
  quantities: DerivedQuantity[],
  prices: Record<string, ResourcePrice>,
) {
  const lines = quantities.map((line) => {
    const priceRow = line.resourceCode ? prices[line.resourceCode] : undefined;
    const compatibleUnit = !priceRow || unitKey(line.unit) === unitKey(priceRow.unit);
    const rawPrice = priceRow?.unit_price;
    const validPrice = rawPrice !== null && rawPrice !== undefined
      && String(rawPrice).trim() !== "" && Number.isFinite(Number(rawPrice)) && Number(rawPrice) >= 0;
    const unitPrice = compatibleUnit && validPrice ? Number(rawPrice) : null;
    const validQuantity = line.quantity !== null && Number.isFinite(line.quantity) && line.quantity >= 0;
    const cost = validQuantity && unitPrice !== null ? Number(line.quantity) * unitPrice : null;
    const partial = cost !== null && Number.isFinite(cost) ? cost : null;
    const priceOrigin: PriceOrigin | null = line.resourceCode
      ? unitPrice === null ? "missing" : "l37_validated"
      : null;
    return { ...line, priceRow, unitPrice, partial, compatibleUnit, priceOrigin };
  });
  const relevant = lines.filter((line) => line.quantity !== null && line.quantity > 0 && line.resourceCode);
  const priced = relevant.filter((line) => line.partial !== null);
  const sum = priced.reduce((total, line) => total + Number(line.partial), 0);
  return {
    lines,
    missingPriceCount: relevant.filter((line) => line.partial === null).length,
    // No available prices is missing data; an explicitly approved zero price is valid.
    subtotal: priced.length > 0 && Number.isFinite(sum) ? sum : null,
    pricedLineCount: priced.length,
  };
}
